import React, { Component } from 'react';
import Logo from "../../assets/Logo.png";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";

interface IReportProps {
    title: any;
    selectedDateRange: any[];
    selectedFromDate: string;
    selectedToDate: string;
    selectedSources: any[];
    selectedGrades: any[];
    selectedProducts: any[];
    selectedSamples: any[];
}

export default class PrintHeader extends Component<IReportProps> {
    checkIfImageExists = async (url: any) => {
        const img = new Image();
        img.src = url;

        if (await img.complete) {
            return true;
        } else {
            img.onload = () => {
                return true;
            };

            img.onerror = () => {
                return false;
            };
        }
    };
    getLabels = (data: any[]) => {
        return data.map(item => item.label).join(', ');
    }
    render() {
        return (
            <Translation>
                {
                    t =>
                        <React.Fragment>
                            <div style={{ paddingTop: "20px" }}>
                                <hr className="hr-line" />
                                <div className='d-flex' style={{ justifyContent: "center", alignItems: "center", padding: "10px 0" }}>
                                    <div className="print-header-left">
                                        <div className="report-title font-weight-bolder">{t(this.props.title)}</div>
                                    </div>
                                    <div className="print-header-right">
                                        {this.checkIfImageExists(
                                            `${window.LMS.SAMPLE_API_URL}/Settings/General/logo`
                                        ) ? (
                                            <img
                                                src={`${window.LMS.SAMPLE_API_URL}/Settings/General/logo`}
                                                alt={`${window.LMS.SAMPLE_API_URL}/Settings/General/logo`}
                                                style={{ height: 70, width: 100 }}
                                            />
                                        ) : (
                                            <></>
                                        )}
                                    </div>

                                </div>
                                <hr className="hr-line" />
                                <div style={{paddingTop: "10px", paddingLeft: "20px"}}>
                                    <div className="row">
                                        <div className="column" style={{width: "50%"}}>
                                            <p><strong>Date Range:</strong> {this.getLabels(this.props.selectedDateRange)}</p>
                                            <p><strong>From Date:</strong> {this.props.selectedFromDate}</p>
                                            <p><strong>To Date:</strong> {this.props.selectedToDate}</p>
                                            <p><strong>Sources:</strong> {this.getLabels(this.props.selectedSources)}</p>
                                        </div>
                                        <div className="column" style={{width: "50%"}}>
                                            <p><strong>Grades:</strong> {this.getLabels(this.props.selectedGrades)}</p>
                                            <p><strong>Products:</strong> {this.getLabels(this.props.selectedProducts)}</p>
                                            <p><strong>Samples:</strong> {this.getLabels(this.props.selectedSamples)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                }
            </Translation>
        )
    }
}